/**
 * Prefer shortSlug, then publicNumber, then id — for /overview/appointment URLs.
 */
export function getCompanyAppointmentUrlSegment(appointment) {
  if (!appointment) return '';
  const { id, shortSlug, publicNumber } = appointment;
  if (shortSlug) return String(shortSlug);
  if (publicNumber != null && publicNumber !== '') {
    const n = Number(publicNumber);
    if (!Number.isNaN(n)) return String(n);
  }
  return id ? String(id) : '';
}

export const isFirestoreAppointmentDocId = (value) => {
  const s = String(value || '');
  return s.length >= 18 && /^[a-zA-Z0-9]+$/.test(s);
};
